import { h } from 'preact';
import { PopAnnotation } from 'rendering/annotations/pop';
import { KNOWN_BUTTON_INTENTS } from 'constants/annotations';
import { RECORDING_STATUSES } from './reporting';
import { COMPOSITION_TYPES, ACTIONS } from 'constants/annotations';

const {
    BACK_BUTTON,
    NEXT_BUTTON,
    RETRY_BUTTON,
    SUBMIT_BUTTON,
    CONFIRMATION_BUTTON
} = KNOWN_BUTTON_INTENTS

export const Buttons = ({ quizId, bus, styles, ...props}) => {
    const { QUIZ } = COMPOSITION_TYPES;
    const baseStyles = styles[QUIZ.BUTTON];
    const backButton = getBackButton(quizId, props);
    const forwardButton = getForwardButton(quizId, props);
    const willSubmit = willForwardSubmit(props);

    return (
        <div className="quiz-buttons" data-will-submit={willSubmit}>
            {
                backButton ?
                    <PopAnnotation
                        bus={bus}
                        {...backButton}
                        styles={{
                            ...baseStyles,
                            ...backButton.styles
                        }}
                    /> : null
            }
            {
                forwardButton ? 
                    <PopAnnotation
                        bus={bus}
                        {...forwardButton}
                        styles={{
                            ...baseStyles,
                            ...forwardButton.styles
                        }}
                    /> : null
            }            
        </div>
    )
}

export const getBackButton = (quizId, {
    buttons = [],
    start = false,
    postSubmit = false,
    recordingResponseStatus = RECORDING_STATUSES.NOT_STARTED
}) => {
    let button;

    if (recordingResponseStatus === RECORDING_STATUSES.IN_PROGRESS || postSubmit) {
        return;
    }

    button = buttons.find(c => c.intent === BACK_BUTTON);

    if (button && start) {
        button = {
            ...button,
            classes: button.classes ? `${button.classes} disabled` : 'disabled'
        }
    }

    if (button) {
        button.actions = applyActions(quizId, button);
    }

    return button;
}

export const getForwardButton = (quizId, {
    answered,
    buttons = [],
    postSubmit = false,
    lastSection = false,
    lastQuestion = false,
    hasSummary = false,
    readOnly = false,
    recordingResponseStatus = RECORDING_STATUSES.NOT_STARTED
}) => {
    if (recordingResponseStatus === RECORDING_STATUSES.IN_PROGRESS) {
        return;
    }

    let button = buttons.find(c => c.intent === NEXT_BUTTON);

    if (
        lastQuestion &&
        lastSection &&
        !postSubmit &&
        recordingResponseStatus === RECORDING_STATUSES.NOT_STARTED
    ) {
        button = buttons.find(c => c.intent === SUBMIT_BUTTON);
    }

    if (
        lastQuestion &&
        lastSection &&
        !postSubmit &&
        recordingResponseStatus !== RECORDING_STATUSES.NOT_STARTED
    ) {
        button = {
            ...button,
            content: 'Back',
            actions: applyActions(quizId, button, ACTIONS.RETRY_QUIZ, 'Back'),
        }
    }

    if (button) {
        button.actions = applyActions(quizId, button);
    }

    if (!postSubmit && lastQuestion && readOnly) {
        button = buttons.find(c => c.intent === NEXT_BUTTON);
        button = {
            ...button,
            content: 'Next',
            classes: button.classes ? `${button.classes} disabled` : 'disabled',
            actions: []
        };
    } else if (
        postSubmit || (
            recordingResponseStatus === RECORDING_STATUSES.SUCCESSFUL &&
            lastSection &&
            lastQuestion &&
            !hasSummary
        )
    ) {
        button = buttons.find(c => c.intent === CONFIRMATION_BUTTON);
        button = {
            ...button,
            content: 'Back',
            actions: applyActions(quizId, button, ACTIONS.RETRY_QUIZ, 'Back'),
        };

    }

    if (!answered) {
        button = {
            ...button,
            classes: button.classes ? `${button.classes} disabled` : 'disabled'
        };
    }

    return button;
}

export const hasActions = (actions = []) => actions.length;

export const applyActions = (quizId, {actions, intent}, action, buttonContent) => {
    if (!hasActions(actions)) {
        const appliedAction = action || DEFAULT_ACTIONS[intent];
        if (appliedAction) {
            return [
                clickQuizAction(quizId, appliedAction),
                // if is back button, send event to reset activities. 
                buttonContent && buttonContent === 'Back' ? clickQuizAction('', 'resetActivities') : {}
            ]
        }
    }

    return actions;
}

export const clickQuizAction = (value, action) => ({
    action,
    event: 'onClick',
    args: {
        value
    }
})

export const willForwardSubmit = ({
    remainingRetries,
    preSubmit,
    lastQuestion,
    lastSection,
    passing,
    recordingResponseStatus = RECORDING_STATUSES.NOT_STARTED
}) => {
    if (
        preSubmit || 
        (
            lastSection &&
            lastQuestion &&
            (passing || remainingRetries === 0) &&
            recordingResponseStatus === RECORDING_STATUSES.NOT_STARTED
        )
    ) {
        return true;
    }

    return false;
}

export const DEFAULT_ACTIONS = {
    [BACK_BUTTON]: 'toPrevious',
    [NEXT_BUTTON]: 'toNext',
    [SUBMIT_BUTTON]: 'submitForm',
    [RETRY_BUTTON]: 'retryQuiz'
}
